exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3sJWs{text-decoration:none}._3sJWs:hover{text-decoration:underline}._3wFsu{color:#000;cursor:default}", ""]);

// exports
exports.locals = {
	"infoLink": "_3sJWs",
	"notLink": "_3wFsu"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/hocs/withTransportInfo/withTransportInfo.css
// module id = 3283
// module chunks = 32